/**
 * Happy Chopper.
 *
 * A smiley whose mouth is a waveform rather than an arc — it reads as a grin at
 * 20px and as what the app does at 200px. Colours are literal rather than
 * themed, because a mark that shifts with the accent stops being a mark.
 */
export function Logo({ size = 20 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden>
      <circle cx="16" cy="16" r="14" fill="#FFCE1F" />
      <circle cx="11" cy="12.5" r="2.1" fill="#241a02" />
      <circle cx="21" cy="12.5" r="2.1" fill="#241a02" />
      <path
        d="M8.5 19.5 Q16 27 23.5 19.5"
        fill="none"
        stroke="#241a02"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

/** Same mark, as a data URI for the favicon. */
export const LOGO_DATA_URI =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Ccircle cx='16' cy='16' r='14' fill='%23FFCE1F'/%3E%3Ccircle cx='11' cy='12.5' r='2.1' fill='%23241a02'/%3E%3Ccircle cx='21' cy='12.5' r='2.1' fill='%23241a02'/%3E%3Cpath d='M8.5 19.5 Q16 27 23.5 19.5' fill='none' stroke='%23241a02' stroke-width='2.6' stroke-linecap='round'/%3E%3C/svg%3E";
